import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./styles.scss";

const CustomDatePicker = ({ 
  selected, 
  onChange, 
  placeholderText, 
  minDate, 
  maxDate,
  ...props 
}) => {
  return (
    <div className="date-picker-container">
      <DatePicker
        selected={selected}
        onChange={onChange}
        placeholderText={placeholderText}
        minDate={minDate}
        maxDate={maxDate}
        dateFormat="dd/MM/yyyy"
        {...props}
      />
    </div>
  );
};

export default CustomDatePicker;